<template>
  <section class="section container pt-3">
    <div class="columns">
      <div class="column">
        <div class="card" @click="$router.push({ path: '/ngine/composer' })">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.freepik.com/512/8317/8317737.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("composer") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card" @click="$router.push({ path: '/ngine/manager' })">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.freepik.com/256/4661/4661361.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("manager") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="card" @click="$router.push({ path: '/ngine/workspace' })">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.freepik.com/512/1599/1599808.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("workspace") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img src="https://via.placeholder.com/48" />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">{reports here}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div
          class="card"
          @click="$router.push({ path: '/ngine/variable-set' })"
        >
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/9757/9757564.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("variable set") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: "NgineIndex",
  components: {},
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.card:hover {
  /* background-color: rgba(70, 70, 70, 0.651) !important; */
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  /* background-color: rgb(29, 29, 29) !important; */
  /* background-color: rgba(0, 174, 255, 0.418) !important; */
  /* background-color: rgba(0, 209, 178, 0.568) !important; */
  /* transition: ease-in-out 0.3s; */
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.card:active {
  /* background-color: rgba(70, 70, 70, 0.651) !important; */
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  /* background-color: rgb(29, 29, 29) !important; */
  /* background-color: rgba(0, 174, 255, 0.418) !important; */
  /* background-color: rgba(0, 209, 178, 0.568) !important; */
  /* transition: ease-in-out 0.3s; */
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
  /* animation: gelatine 0.5s infinite; */
}
</style>
